import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=48227776&"
import script from "./Calendar.vue?vue&type=script&lang=ts&"
export * from "./Calendar.vue?vue&type=script&lang=ts&"
import style0 from "./Calendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCalendar,VChip,VDivider,VSheet})
